import { AbstractControl } from '@angular/forms';
import { ValidatorModel, ValidatorsHelper } from '../../../core/helpers/validators.helper';
import { Component, OnInit, Input } from '@angular/core';

@Component({
	selector: 'app-password-strength-indicator',
	templateUrl: './password-strength-indicator.component.html',
	styleUrls: ['./password-strength-indicator.component.scss']
})
export class PasswordStrengthIndicatorComponent implements OnInit {

	@Input() control: AbstractControl;
	passwordValidators: ValidatorModel[];

	constructor() {
		this.passwordValidators = ValidatorsHelper.getPasswordValidators();
	}

	ngOnInit(): void {
		this.checkPasswordStrength();
	}

	checkPasswordStrength() {
		this.control.valueChanges.subscribe(val => {
			this.passwordValidators = ValidatorsHelper.validatePassword(val);
		});
	}

}
